import script from "./FlowerDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowerDetail.vue?vue&type=script&lang=ts&setup=true"

import "./FlowerDetail.vue?vue&type=style&index=0&id=e0d9e4bc&lang=scss"

const __exports__ = script;

export default __exports__